__webpack_require__.p = "https://development.quickview.kindle.amazon.dev/";